// extracted by mini-css-extract-plugin
export default {"container":"ShiftDetail_container__-UFIx","centerBlock":"ShiftDetail_centerBlock__LB2HC"};